module.exports = __webpack_public_path__ + "img/m4v.3a52314f.svg";